export enum FeaturesSwitch{
    none= 0,
    // eslint-disable-next-line no-bitwise
    customerMappings= 1
}
